import { api } from '@/lib/api/client';
import type { JobRun, JobDefinition, JobRunFilters } from './types';

/**
 * GET /api/admin/job-runs — this tenant's own background-job run history.
 * Bare bounded list (no pagination envelope), same as medicines.js's ?q=
 * search — an admin monitoring view, not a page-through list. Which tenant
 * is scoped server-side from the requester's own session; nothing here can
 * ask for another hospital's rows.
 */
export function fetchJobRuns(filters: JobRunFilters): Promise<JobRun[]> {
  return api.get('/admin/job-runs', { query: filters });
}

/** GET /api/admin/job-runs/jobs — the live job registry, for the filter dropdown. */
export function fetchJobDefinitions(): Promise<JobDefinition[]> {
  return api.get('/admin/job-runs/jobs');
}
